<form class="app-flex-form" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === agentCardFilterKey.Mentions) {
      <mat-selection-list [formField]="formTree.mentions">
        @for (mention of mentionOptions; track mention.value) {
          <mat-list-option [value]="mention.value" (click)="$event.stopPropagation()">
            {{ mention.label }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === agentCardFilterKey.DepartmentCode) {
      <div class="p-2 border-b border-gray-3">
        <mat-form-field appearance="outline" class="w-full !mb-0" subscriptSizing="dynamic">
          <mat-icon matPrefix class="mr-2 text-gray-8">search</mat-icon>
          <input
            matInput
            placeholder="Filtrer par nom ou n°..."
            aria-label="Filtrer les départements"
            [value]="departmentSearch()"
            (input)="onDepartmentSearchInput($event)"
            (click)="$event.stopPropagation()"
          />
        </mat-form-field>
      </div>
      <mat-selection-list [formField]="formTree.departmentCode" class="max-h-60 overflow-y-auto">
        @for (dept of filteredDepartments(); track dept.code) {
          <mat-list-option [value]="dept.code" (click)="$event.stopPropagation()">
            {{ dept.label }}
          </mat-list-option>
        }
        @if (filteredDepartments().length === 0) {
          <div class="p-4 text-xs text-center text-gray-9 italic">Aucun département trouvé</div>
        }
      </mat-selection-list>
    }
  }
</form>
